import React from "react";
import { Button, dialog, Modal } from "../../../nq-component";
import {
  addSchemaUseCase,
  updateSchemaUseCase,
  deleteSchemaUseCase,
} from "../../../usecases/schema/usecases";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  getObjectUseCase,
  upsertUseCase,
} from "../../../usecases/object";
import { exportCSVUseCase } from "../../../usecases/csv/usecases";
import { Progress, InfiniteScroll } from "../../../nq-component";
import withRouter from "../../../withRouter";
import Search from "../../../components/Search";
import BaseListPage from "../../../base/BaseListPage";
import NavBar from "../../../components/navbar";
import InputFactory from "../../../components/InputFactory";
import EmployeeDetails from "./components/OnBoardDetails";
import excludeFields from "./components/ExcludeField";
import DialogCreate from "./components/DialogCreate";
import TableUser from "../../../components/TableUser";
import DialogDelete from "./components/DialogDelete";
import DialogReset from "./components/DialogReset";

import Table from "../../../components/Table";
import OnBoardDetails from "./components/OnBoardDetails";
import ApplicantBoardingListPresenter from "./ApplicantBoardingListPresenter";
import OnBoardApplicantDetails from "./components/OnBoardApplicantDetails";
import DialogUpdate from "./components/DialogUpdate";
import DialogHired from "./components/DialogHired";

import { footer, object } from "framer-motion/client";
import DialogSuccess from "./components/DialogSuccess";

class ApplicantBoardingListPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new ApplicantBoardingListPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase(),
      exportCSVUseCase(),
      addSchemaUseCase(),
      updateSchemaUseCase(),
      deleteSchemaUseCase(),
      getObjectUseCase()
    );
    this.state = {
      objects: [],
      selected: [],
      object: {},
      loading: false,
      total: 0,
      count: 0,
      showDetails: false,
      applicantDetails: {},
      showModal: false,
      formData: {
        onBoardRemarks: "",
        attachment: "",
      },
      title: [],
    };
  }

  getCollectionName() {
    return "online_applicants";
  }

  setTitle(objects) {
    this.setState({ title: objects });
  }

  getToken() {
    return this.getParams().token;
  }

  onChangeObject(value, field) {
    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        [field]: value,
      },
    }));
  }

  successModal(message) {
    dialog.close();
    dialog.fire({
      html: <DialogSuccess message={message} />,
      footer: false,
    });
  }

  handleClickHireSubmit(startDateTime, endDateTime, employmentStatus) {
    const { applicantDetails } = this.state;
    console.log(applicantDetails);
    dialog.close();
    this.presenter.handleClickHireApplicant(
      applicantDetails,
      startDateTime,
      endDateTime,
      employmentStatus
    );
  }

  handleHiredSubmit() {
    dialog.fire({
      html: (
        <>
          <DialogHired handleSubmit={this.handleClickHireSubmit.bind(this)} />
        </>
      ),
      footer: false,
    });
  }

  // clickData(object, index) {
  //   this.setState({ showDetails: true, applicantDetails: object });
  // }

  clickData(object) {
    const { objects } = this.state;
    const isOnboardingComplete =
      objects.length === 0
        ? false
        : objects.every(
            (object) =>
              object.status === "Hired" || object.status === "Not Hired"
          );

    this.navigateTo(
      `/onboarding/applicant/form/${isOnboardingComplete}/${object?.interviewCoordinator}/${object?.id}`
    );
  }

  hideFilter() {
    this.setState({ showDetails: false });
  }

  onClickEdit() {
    const { applicantDetails } = this.state;
    this.presenter.onClickEdit(applicantDetails);
  }

  handleDelete() {
    const { applicantDetails } = this.state;
    this.presenter.onClickDelete(applicantDetails);
  }

  onSubmitPassword() {
    this.presenter.onSubmitPassword(this.state.password);
  }
  onChange(value, field) {
    this.setState((prevState) => ({
      password: {
        ...prevState.password,
        [field]: value,
      },
    }));
  }

  onClickAdd(object) {
    const schema = this.getSchemas();
    const schemas = this.getSchema(this.getCollectionName());
    const formData = this.state.formData;

    dialog.fire({
      html: (
        <DialogCreate
          schema={schema}
          schemas={schemas}
          objects={object}
          onChangeData={this.onChangeObject.bind(this)}
          handleSubmit={this.handleSubmit.bind(this)}
        />
      ),
      footer: false,
    });
  }

  handleUpdateApplicant() {
    const { applicantDetails, formData } = this.state;
    this.presenter.handleUpdateApplicant(applicantDetails, formData);
  }

  handleUpdate() {
    const { applicantDetails } = this.state;
    dialog.fire({
      html: (
        <>
          <DialogUpdate
            empDetails={applicantDetails}
            clickUpdate={this.handleUpdateApplicant.bind(this)}
            clickClose={() => dialog.close()}
          />
        </>
      ),
      footer: false,
    });
  }

  handleDeleteFile(index) {
    this.setState((prevState) => {
      const applicantDetails = { ...prevState?.applicantDetails };

      if (Array.isArray(applicantDetails.onBoardAttachment)) {
        applicantDetails.onBoardAttachment =
          applicantDetails.onBoardAttachment.filter((_, i) => i !== index);
      }

      return { applicantDetails };
    });
  }

  onclickReset() {
    dialog.fire({
      html: (
        <>
          <DialogReset
            onChangeField={this.onChange.bind(this)}
            clickSubmit={this.onSubmitPassword.bind(this)}
            clickClose={() => dialog.close()}
          />
        </>
      ),
      footer: false,
    });
  }

  toggleModal = () => {
    this.setState((prevState) => ({ showModal: !prevState.showModal }));
  };

  closeModal = () => {
    this.setState({ showModal: false });
    setTimeout(() => {
      this.forceUpdate();
    }, 100);
  };

  clickDataApplicant() {
    this.navigateTo("/recruiter/onboard-list");
  }

  getAcl() {
    const user = this.getCurrentUser();
    return {
      read: ["*", user.id],
      write: ["*", user.id],
    };
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const schemas = this.getSchemas();
    const {
      objects,
      selected,
      count,
      progress,
      applicantDetails,
      formData,
      showModal,
      total,
      title,
    } = this.state;
    const params = this.getParams();

    const isOnboardingComplete =
      objects.length === 0
        ? false
        : objects.every(
            (object) =>
              object.status === "Hired" || object.status === "Not Hired"
          );

    if (!schema) return <Progress />;
    const user = this.getCurrentUser();
    return (
      <>
        <NavBar user={user} />

        <div className="overflow-auto">
          <InfiniteScroll
            className="h-100"
            loadMore={this.loadMore.bind(this)}
            hasMore={!progress && count > objects.length}
          >
            <div className="p-3 p-lg-4">
              <div className="d-flex justify-content-between align-items-center">
                <h1 className="fw-bold text-capitalize">{title[0]?.name}</h1>
                <div className="text-nowrap">
                  <span className="ms-2">
                    {selected.length > 0 ? "Selected: " : "Total: "}
                  </span>
                  <span className="fs-sm text-nowrap">
                    {selected.length > 0 ? total : objects.length}
                  </span>
                  <span className="ms-1">of </span>
                  <span className="fs-sm text-nowrap">{total}</span>
                </div>
              </div>

              <div
                className={`d-flex align-items-center justify-content-between bg-white rounded p-3 col-lg-3 mb-3 border ${
                  isOnboardingComplete
                    ? "border-success bg-light-success"
                    : "border-warning bg-light-warning"
                }`}
              >
                <div>
                  <label className="fw-bold text-dark">
                    <b>Status:</b>
                  </label>
                  <p
                    className={`m-0 ${
                      isOnboardingComplete ? "text-success" : "text-warning"
                    }`}
                  >
                    {isOnboardingComplete ? "Complete" : "Ongoing"}
                  </p>
                </div>
                <i
                  className={`bi ${
                    isOnboardingComplete
                      ? "bi-check-circle-fill text-success"
                      : "bi-exclamation-circle-fill text-warning"
                  } fs-4`}
                ></i>
              </div>

              <div className="d-flex">
                {this.state.showDetails && applicantDetails && (
                  <div className="w-50 me-2">
                    <OnBoardApplicantDetails
                      empDetails={applicantDetails}
                      clickReset={this.onclickReset.bind(this)}
                      clickEdit={this.onClickEdit.bind(this)}
                      handleUpdate={this.handleUpdate.bind(this)}
                      onChangeData={this.onChangeObject.bind(this)}
                      handleSubmit={this.handleHiredSubmit.bind(this)}
                      handleDeleteFile={this.handleDeleteFile.bind(this)}
                    />
                  </div>
                )}
                <div className=" w-100">
                  <Table
                    fields={schema.fields}
                    onClick={this.clickData.bind(this)}
                    objects={objects}
                    // selectable
                    // collapsable
                    excludeFields={Object.keys(schema.fields).reduce(
                      (acc, key) => {
                        const options = schema.fields[key];
                        if (excludeFields.includes(key)) {
                          acc.push(key);
                        }
                        if (options.read === false) {
                          acc.push(key);
                        }
                        switch (options._type || options.type) {
                          case "Relation":
                          case "Array":
                          case "Object":
                          case "File":
                            acc.push(key);
                            break;
                          default:
                        }
                        return acc;
                      },
                      excludeFields
                    )}
                    selected={selected}
                    onSelect={this.onSelect.bind(this)}
                    onSelectAll={this.onSelectAll.bind(this)}
                    progress={progress}
                    onClickItem={this.onClickItem.bind(this)}
                    onSort={this.onClickSort.bind(this)}
                    className="mt-1"
                  />
                </div>
              </div>
            </div>
          </InfiniteScroll>
        </div>
        {user.roles[0]?.id === "HR" && (
          <div className="position-fixed bottom-0 end-0 m-4">
            <Button
              className="btn shadow-sm text-white"
              // onClick={this.onClickAdd.bind(this)}
              onClick={this.toggleModal}
              style={{
                width: "50px",
                height: "50px",
                borderRadius: "25px",
                backgroundColor: "#e09552",
              }}
            >
              <i className="bi bi-plus-lg" />
            </Button>
          </div>
        )}

        <Modal isOpen={showModal} closable size="md">
          <Modal.Body>
            <DialogCreate
              schema={schema}
              schemas={schemas}
              objects={formData}
              onChangeData={(value, field) =>
                this.setState((prevState) => ({
                  formData: { ...prevState.formData, [field]: value },
                }))
              }
              handleSubmit={this.handleSubmit}
              handleClose={this.closeModal.bind(this)}
            />
          </Modal.Body>
        </Modal>
      </>
    );
  }
}

export default withRouter(ApplicantBoardingListPage);
